export const error404Traductions = {
    en: {
        error: 'La page que vous recherchez n\'est pas disponible',
        help: 'Aller dans les classes',
    },
    fr: {
        error: 'La page que vous recherchez n\'est pas disponible',
        help: 'Aller dans les classes',
    }
}